import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { KcmStore } from '../kcm.store';
import { Observable } from 'rxjs';
import { RequestState } from '@shared/models/request-state';
import { KcmView } from '../models/kcm.view';
import { ThemeService } from '@shared/services/theme.service';

@Component({
  selector: 'app-kcm-card',
  templateUrl: './kcm-card.component.html',
  styleUrls: ['./kcm-card.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KcmCardComponent implements OnChanges {
  @Input() depAirport?: string | null;
  kcm$?: Observable<RequestState<KcmView>>;
  theme$ = this.themeService.theme$;

  constructor(
    private kcmStore: KcmStore,
    private themeService: ThemeService,
  ) {}

  ngOnChanges(): void {
    this.setObservable();
  }

  onExpand(): void {
    this.setObservable();
  }

  refresh(): void {
    this.setObservable(true);
  }

  private setObservable(isRefresh = false): void {
    if (this.depAirport) {
      if (isRefresh) {
        this.kcm$ = this.kcmStore.refreshKcm(this.depAirport);
      } else {
        this.kcm$ = this.kcmStore.getKcm(this.depAirport);
      }
    }
  }
}
